import React, { useEffect, useState } from "react";
import "./FormFillUpStep3.css";
import HomeServices from "../../Services/HomeServices";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const FormFillUpStep3 = () => {
  const [loading, setLoading] = useState(false);
  const [primaryApplicantData, setPrimaryApplicantData] = useState([]);
  const [alreadyExistedData, setAlreadyExistedData] = useState(false);
  const [existedDataIds, setExistedDataIds] = useState({}); // Object to store child IDs by index
  const [applicantId, setApplicantId] = useState("");
  const [childCount, setChildCount] = useState(0);
  const [activeChildTab, setActiveChildTab] = useState(0); // Track active child tab
  const [childForms, setChildForms] = useState([]); // Array of child form data
  const [completedChildDataCount, setCompletedChildDataCount] = useState(null);
  const [primaryApplicantChildCount, setPrimaryApplicantChildCount] =
    useState(null);
  const navigate = useNavigate();

  // Initial form data structure for a child
  const initialFormData = {
    // Personal Information
    firstName: "",
    middleName: "",
    lastName: "",
    otherName: "",
    nativeLanguage: "",
    gender: "",
    dateOfBirth: "",
    countryOfBirth: "",
    cityOfBirth: "",
    countryOfCitizenship: "",
    currentCountryOfResidence: "",

    // Marital Information
    maritalStatus: "",
    spouseCount: 1,
    childCount: "",
    dateOfMarriage: "",

    // Passport Information
    passportNo: "",
    issueDate: "",
    expiryDate: "",
    countryOfIssue: "",

    // Contact Information
    telephoneNo: "",
    emailId: "",
    mailingAddress: "",
    permanentAddress: "",

    // Canadian Immigration Information
    UCIno: "",
    firstTimeEnteredInCanada: "",
    placeOfEnteredInCanada: "",
    lastTimeEnteredInCanada: "",
    totalFamilyMemberIncludingSpouseAndChild: "",
    provinceOfConsiderLiving: "",

    // Application History
    didAppliedToExpressEntryCanadaBefore: "",
    EEno: "",
    receivedNominationCertificateFromProvinceOrTerritory: "",
    moneyBroughtToCanada: "",

    // Relatives in Canada
    relativesInCanada: "",
    relativesInCanadaResidentWith: "",
    relativesInCanadaWithCitizenOrPermanentResidentOfCanada: "",
    name: "",
    relation: "",
    statusInCanada: "",
    cityOrProvinceOfResidence: "",

    // Immigration History Questions - Individual fields
    HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada:
      "",
    HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry:
      "",
    UNHCR: "",
    CSQ: "",
    HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry:
      "",
    HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity:
      "",
    HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectives:
      "",
    HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives:
      "",
    HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity:
      "",
    HasApplicantBeenDetainedIncarceratedorPutinJail: "",
    HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder: "",

    // Remarks fields for "Yes" answers
    HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks:
      "",
    HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks:
      "",
    UNHCRRemarks: "",
    CSQRemarks: "",
    HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks:
      "",
    HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks:
      "",
    HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectivesRemarks:
      "",
    HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks:
      "",
    HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks:
      "",
    HasApplicantBeenDetainedIncarceratedorPutinJailRemarks: "",
    HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks: "",
  };

  // Immigration history questions mapping
  const immigrationQuestions = [
    {
      id: 1,
      text: "Has Applicant's been convicted of a crime or offence in Canada for which a pardon has not been granted under the Criminal Records Act of Canada?",
      field:
        "HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada",
      remarksField:
        "HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks",
    },
    {
      id: 2,
      text: "Has Applicant's ever committed, been arrested for, been charged with or convicted of any criminal offence in any country?",
      field:
        "HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry",
      remarksField:
        "HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks",
    },
    {
      id: 3,
      text: "Has Applicant's made previous claims for refugee protection in Canada or at a Canadian visa office abroad, in any other country or countries, or with the United Nations High Commissioner for Refugees (UNHCR)?",
      field: "UNHCR",
      remarksField: "UNHCRRemarks",
    },
    {
      id: 4,
      text: "Has Applicant's been refused refugee status, or an immigrant or permanent resident visa (including a Certificat de sélection du Québec (CSQ) or application to the Provincial nominee Program) or visitor or temporary resident visa, to Canada or any other country?",
      field:
        "HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry",
      remarksField:
        "HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks",
    },
    {
      id: 5,
      text: "Has Applicant's been involved in an act of genocide, a war crime or in the commission of a crime against humanity?",
      field:
        "HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity",
      remarksField:
        "HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks",
    },
    {
      id: 6,
      text: "Has Applicant's used, planned or advocated the use of armed struggle or violence to reach political, religious or social objectives?",
      field:
        "HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectives",
      remarksField:
        "HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectivesRemarks",
    },
    {
      id: 7,
      text: "Has Applicant's been associated with a group that used, uses, advocated or advocates the use of armed struggle or violence to reach political, religious or social objectives?",
      field:
        "HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives",
      remarksField:
        "HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks",
    },
    {
      id: 8,
      text: "Has Applicant's been a member of an organization that is or was engaged in an activity that is part of a pattern of criminal activity?",
      field:
        "HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity",
      remarksField:
        "HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks",
    },
    {
      id: 9,
      text: "Has Applicant's been detained, incarcerated, or put in jail?",
      field: "HasApplicantBeenDetainedIncarceratedorPutinJail",
      remarksField: "HasApplicantBeenDetainedIncarceratedorPutinJailRemarks",
    },
    {
      id: 10,
      text: "Has Applicant's had any serious disease or physical or mental disorder?",
      field: "HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder",
      remarksField:
        "HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks",
    },
  ];

  const fetchApplicantData = async () => {
    try {
      setLoading(true);
      const res = await HomeServices.getPrimariApplicantData();
      console.log("Child data response:", res);

      if (res?.status) {
        // Set applicant ID from primary applicant data
        if (res?.data?.[0]?.PrimaryApplicantData?._id) {
          setApplicantId(res.data[0].PrimaryApplicantData._id);
        }

        // Check if child count exists and create forms accordingly
        const primaryData = res?.data?.[0]?.PrimaryApplicantData;
        setPrimaryApplicantChildCount(
          res?.data?.[0]?.PrimaryApplicantData?.childCount,
        );
        setCompletedChildDataCount(
          res?.data?.[0]?.PrimaryApplicantData?.PrimaryApplicantChildData
            ?.length,
        );
        if (primaryData) {
          // Get child count from primary applicant data
          const childCountFromAPI = primaryData.childCount || 0;
          setChildCount(childCountFromAPI);

          // Get existing child data
          const existingChildren = primaryData.PrimaryApplicantChildData || [];

          // Initialize child forms array
          const initialChildForms = [];
          const childIds = {};

          // Create forms for each child
          for (let i = 0; i < childCountFromAPI; i++) {
            // Check if there's existing data for this child index
            const existingChild = existingChildren[i];

            if (existingChild && existingChild._id) {
              // Child data exists - mark as already existed and store ID
              childIds[i] = existingChild._id;

              // Map existing data to form
              const mappedData = { ...initialFormData };

              Object.keys(initialFormData).forEach((field) => {
                if (existingChild[field] !== undefined) {
                  let value = existingChild[field];

                  // Handle date fields - convert from ISO format to YYYY-MM-DD
                  if (
                    field === "dateOfBirth" ||
                    field === "dateOfMarriage" ||
                    field === "issueDate" ||
                    field === "expiryDate" ||
                    field === "firstTimeEnteredInCanada" ||
                    field === "lastTimeEnteredInCanada"
                  ) {
                    if (value && typeof value === "string") {
                      // Extract YYYY-MM-DD from ISO string
                      const dateMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
                      if (dateMatch) {
                        value = dateMatch[1];
                      }
                    }
                  }

                  // Handle numeric fields
                  if (
                    field === "UCIno" ||
                    field === "EEno" ||
                    field === "spouseCount" ||
                    field === "childCount" ||
                    field === "totalFamilyMemberIncludingSpouseAndChild" ||
                    field === "telephoneNo"
                  ) {
                    value = value?.toString() || "";
                  }

                  mappedData[field] = value || "";
                }
              });

              initialChildForms.push(mappedData);
            } else {
              // No existing data for this child - use empty form
              initialChildForms.push({ ...initialFormData });
            }
          }

          // Update state
          setAlreadyExistedData(existingChildren.length > 0);
          setExistedDataIds(childIds);
          setChildForms(initialChildForms);

          if (childCountFromAPI > 0) {
            toast.success(`Loaded data for ${childCountFromAPI} child(ren)`);
          } else {
            toast.error("No children found for this applicant.");
          }
        }
      } else {
        toast.error("No data available.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to load applicant data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplicantData();
  }, []);

  // Handle form field changes for specific child
  const handleChange = (childIndex, field, value) => {
    setChildForms((prev) => {
      const updatedForms = [...prev];
      updatedForms[childIndex] = {
        ...updatedForms[childIndex],
        [field]: value,
      };
      return updatedForms;
    });
  };

  // Handle immigration history field changes for specific child
  const handleImmigrationFieldChange = (childIndex, field, value) => {
    setChildForms((prev) => {
      const updatedForms = [...prev];
      updatedForms[childIndex] = {
        ...updatedForms[childIndex],
        [field]: value,
      };
      return updatedForms;
    });

    // If user selects "No", clear the corresponding remarks field
    if (value === "No") {
      const question = immigrationQuestions.find((q) => q.field === field);
      if (question && question.remarksField) {
        setChildForms((prev) => {
          const updatedForms = [...prev];
          updatedForms[childIndex] = {
            ...updatedForms[childIndex],
            [question.remarksField]: "",
          };
          return updatedForms;
        });
      }

      // Special handling for CSQ field
      if (field === "CSQ" && value === "No") {
        setChildForms((prev) => {
          const updatedForms = [...prev];
          updatedForms[childIndex] = {
            ...updatedForms[childIndex],
            CSQRemarks: "",
          };
          return updatedForms;
        });
      }
    }
  };

  // Handle remarks field changes for specific child
  const handleRemarksChange = (childIndex, field, value) => {
    setChildForms((prev) => {
      const updatedForms = [...prev];
      updatedForms[childIndex] = {
        ...updatedForms[childIndex],
        [field]: value,
      };
      return updatedForms;
    });
  };

  // Handle submit for specific child
  const handleChildSubmit = async (e, childIndex) => {
    e.preventDefault();

    if (childIndex >= childForms.length) {
      toast.error("Invalid child index");
      return;
    }

    const childData = childForms[childIndex];

    // Prepare submission data according to Postman body structure
    const submissionData = {
      // Personal Information
      firstName: childData.firstName,
      middleName: childData.middleName,
      lastName: childData.lastName,
      otherName: childData.otherName,
      nativeLanguage: childData.nativeLanguage,
      gender: childData.gender,
      dateOfBirth: childData.dateOfBirth,
      countryOfBirth: childData.countryOfBirth,
      cityOfBirth: childData.cityOfBirth,
      countryOfCitizenship: childData.countryOfCitizenship,
      currentCountryOfResidence: childData.currentCountryOfResidence,

      // Marital Information
      maritalStatus: childData.maritalStatus,
      spouseCount: childData.spouseCount ? parseInt(childData.spouseCount) : 1,
      childCount: childData.childCount ? parseInt(childData.childCount) : "",
      dateOfMarriage: childData.dateOfMarriage,

      // Passport Information
      passportNo: childData.passportNo,
      issueDate: childData.issueDate,
      expiryDate: childData.expiryDate,
      countryOfIssue: childData.countryOfIssue,

      // Contact Information
      telephoneNo: childData.telephoneNo,
      emailId: childData.emailId,
      mailingAddress: childData.mailingAddress,
      permanentAddress: childData.permanentAddress,

      // Canadian Immigration Information
      UCIno: childData.UCIno ? parseInt(childData.UCIno) : "",
      firstTimeEnteredInCanada: childData.firstTimeEnteredInCanada,
      placeOfEnteredInCanada: childData.placeOfEnteredInCanada,
      lastTimeEnteredInCanada: childData.lastTimeEnteredInCanada,
      totalFamilyMemberIncludingSpouseAndChild:
        childData.totalFamilyMemberIncludingSpouseAndChild
          ? parseInt(childData.totalFamilyMemberIncludingSpouseAndChild)
          : "",
      provinceOfConsiderLiving: childData.provinceOfConsiderLiving,

      // Application History
      didAppliedToExpressEntryCanadaBefore:
        childData.didAppliedToExpressEntryCanadaBefore,
      EEno: childData.EEno ? parseInt(childData.EEno) : "",
      receivedNominationCertificateFromProvinceOrTerritory:
        childData.receivedNominationCertificateFromProvinceOrTerritory,
      moneyBroughtToCanada: childData.moneyBroughtToCanada,

      // Relatives in Canada
      relativesInCanadaWithCitizenOrPermanentResidentOfCanada:
        childData.relativesInCanadaWithCitizenOrPermanentResidentOfCanada,
      relativesInCanada: childData?.relativesInCanada,
      name: childData.name,
      relation: childData.relation,
      statusInCanada: childData.statusInCanada,
      cityOrProvinceOfResidence: childData.cityOrProvinceOfResidence,
      relativesInCanadaResidentWith: childData?.relativesInCanadaResidentWith,

      // Immigration History
      HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada:
        childData.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada,
      HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry:
        childData.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry,
      UNHCR: childData.UNHCR,
      CSQ: childData.CSQ,
      HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry:
        childData.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry,
      HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity:
        childData.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity,
      HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectives:
        childData.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectives,
      HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives:
        childData.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives,
      HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity:
        childData.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity,
      HasApplicantBeenDetainedIncarceratedorPutinJail:
        childData.HasApplicantBeenDetainedIncarceratedorPutinJail,
      HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder:
        childData.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder,

      // Remarks fields
      HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks:
        childData.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks,
      HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks:
        childData.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks,
      UNHCRRemarks: childData.UNHCRRemarks,
      CSQRemarks: childData.CSQRemarks,
      HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks:
        childData.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks,
      HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks:
        childData.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks,
      HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectivesRemarks:
        childData.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectivesRemarks,
      HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks:
        childData.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks,
      HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks:
        childData.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks,
      HasApplicantBeenDetainedIncarceratedorPutinJailRemarks:
        childData.HasApplicantBeenDetainedIncarceratedorPutinJailRemarks,
      HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks:
        childData.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks,

      // Primary applicant id
      primaryApplicantId: applicantId,
    };

    console.log(`Submitted data for Child ${childIndex + 1}:`, submissionData);

    try {
      setLoading(true);
      const childId = existedDataIds[childIndex];
      const res = !childId
        ? await HomeServices?.createPrimaryApplicantChildData(submissionData)
        : await HomeServices?.updatePrimaryApplicantChildData(
            submissionData,
            childId,
          );

      console.log("Response for child:", res);

      if (res?.status) {
        // Update the child ID if this was a create operation
        if (!childId && res.data?._id) {
          setExistedDataIds((prev) => ({
            ...prev,
            [childIndex]: res.data._id,
          }));
        }

        // Update completed child data count
        const resUpdated = await HomeServices.getPrimariApplicantData();
        if (resUpdated?.status) {
          setCompletedChildDataCount(
            resUpdated?.data?.[0]?.PrimaryApplicantData
              ?.PrimaryApplicantChildData?.length,
          );
        }

        toast.success(
          childId
            ? `Child ${childIndex + 1} data updated successfully!`
            : `Child ${childIndex + 1} data created successfully!`,
        );
      } else {
        toast.error(res?.message || "Operation failed");
      }
    } catch (error) {
      console.log(error);
      toast.error(`Failed to submit data for Child ${childIndex + 1}`);
    } finally {
      setLoading(false);
    }
  };

  // Render immigration history section for a specific child
  const renderImmigrationHistory = (childIndex) => {
    const childData = childForms[childIndex] || {};

    return (
      <div className="tab-content">
        <div className="questions-header">
          <h3>Immigration History Questions</h3>
          <p className="instructions">
            Answer YES/NO for each question. If yes, provide details.
          </p>
        </div>

        <div className="questions-container">
          {immigrationQuestions.map((question) => (
            <div key={question.id} className="question-group">
              <div className="question-text">
                <span className="question-number">{question.id}.</span>
                <span>{question.text}</span>
              </div>

              <div className="question-response">
                <div className="answer-select">
                  <select
                    value={childData[question.field] || ""}
                    onChange={(e) =>
                      handleImmigrationFieldChange(
                        childIndex,
                        question.field,
                        e.target.value,
                      )
                    }
                    className="answer-dropdown"
                  >
                    <option value="">Select</option>
                    <option value="Yes">YES</option>
                    <option value="No">NO</option>
                  </select>
                </div>
              </div>

              {/* Show remarks textarea if answer is "Yes" */}
              {question.remarksField && childData[question.field] === "Yes" && (
                <div className="remarks-section">
                  <label className="remarks-label">
                    Please provide details:
                  </label>
                  <textarea
                    value={childData[question.remarksField] || ""}
                    onChange={(e) =>
                      handleRemarksChange(
                        childIndex,
                        question.remarksField,
                        e.target.value,
                      )
                    }
                    placeholder="Enter details..."
                    rows="3"
                    className="remarks-textarea"
                  />
                </div>
              )}
            </div>
          ))}

          {/* CSQ field - Separate from the immigrationQuestions array */}
          <div className="question-group">
            <div className="question-text">
              <span className="question-number">11.</span>
              <span>
                Has Applicant received a Certificat de sélection du Québec
                (CSQ)?
              </span>
            </div>

            <div className="question-response">
              <div className="answer-select">
                <select
                  value={childData.CSQ || ""}
                  onChange={(e) =>
                    handleImmigrationFieldChange(
                      childIndex,
                      "CSQ",
                      e.target.value,
                    )
                  }
                  className="answer-dropdown"
                >
                  <option value="">Select</option>
                  <option value="Yes">YES</option>
                  <option value="No">NO</option>
                </select>
              </div>
            </div>

            {/* Show remarks textarea if CSQ answer is "Yes" */}
            {childData.CSQ === "Yes" && (
              <div className="remarks-section">
                <label className="remarks-label">
                  Please provide CSQ details:
                </label>
                <textarea
                  value={childData.CSQRemarks || ""}
                  onChange={(e) =>
                    handleRemarksChange(
                      childIndex,
                      "CSQRemarks",
                      e.target.value,
                    )
                  }
                  placeholder="Enter CSQ details..."
                  rows="3"
                  className="remarks-textarea"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Render form for a specific child
  const renderChildForm = (childIndex) => {
    if (childIndex >= childForms.length) return null;

    const childData = childForms[childIndex] || {};
    const childExists = !!existedDataIds[childIndex];

    return (
      <>
        <form
          key={childIndex}
          onSubmit={(e) => handleChildSubmit(e, childIndex)}
        >
          <div className="form-columns">
            {/* Left Column */}
            <div className="form-column">
              <h2 className="section-title">Personal Information</h2>

              <div className="form-group">
                <label htmlFor={`firstName-${childIndex}`}>First Name</label>
                <input
                  type="text"
                  id={`firstName-${childIndex}`}
                  value={childData.firstName}
                  onChange={(e) =>
                    handleChange(childIndex, "firstName", e.target.value)
                  }
                  placeholder="Enter first name"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`middleName-${childIndex}`}>Middle Name</label>
                <input
                  type="text"
                  id={`middleName-${childIndex}`}
                  value={childData.middleName}
                  onChange={(e) =>
                    handleChange(childIndex, "middleName", e.target.value)
                  }
                  placeholder="Enter middle name"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`lastName-${childIndex}`}>
                  Last Name/Surname
                </label>
                <input
                  type="text"
                  id={`lastName-${childIndex}`}
                  value={childData.lastName}
                  onChange={(e) =>
                    handleChange(childIndex, "lastName", e.target.value)
                  }
                  placeholder="Enter last name"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`otherName-${childIndex}`}>
                  Any other name used in Past
                </label>
                <input
                  type="text"
                  id={`otherName-${childIndex}`}
                  value={childData.otherName}
                  onChange={(e) =>
                    handleChange(childIndex, "otherName", e.target.value)
                  }
                  placeholder="Enter any other names used"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`nativeLanguage-${childIndex}`}>
                  Native Language
                </label>
                <input
                  type="text"
                  id={`nativeLanguage-${childIndex}`}
                  value={childData.nativeLanguage}
                  onChange={(e) =>
                    handleChange(childIndex, "nativeLanguage", e.target.value)
                  }
                  placeholder="Enter native language"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`gender-${childIndex}`}>Gender</label>
                <select
                  id={`gender-${childIndex}`}
                  value={childData.gender}
                  onChange={(e) =>
                    handleChange(childIndex, "gender", e.target.value)
                  }
                >
                  <option value="">Select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor={`dateOfBirth-${childIndex}`}>
                  Date of Birth
                </label>
                <input
                  type="date"
                  id={`dateOfBirth-${childIndex}`}
                  value={childData.dateOfBirth}
                  onChange={(e) =>
                    handleChange(childIndex, "dateOfBirth", e.target.value)
                  }
                />
              </div>

              <div className="form-group">
                <label htmlFor={`countryOfBirth-${childIndex}`}>
                  Country Of Birth
                </label>
                <input
                  type="text"
                  id={`countryOfBirth-${childIndex}`}
                  value={childData.countryOfBirth}
                  onChange={(e) =>
                    handleChange(childIndex, "countryOfBirth", e.target.value)
                  }
                  placeholder="Enter country of birth"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`cityOfBirth-${childIndex}`}>
                  City/Town of Birth
                </label>
                <input
                  type="text"
                  id={`cityOfBirth-${childIndex}`}
                  value={childData.cityOfBirth}
                  onChange={(e) =>
                    handleChange(childIndex, "cityOfBirth", e.target.value)
                  }
                  placeholder="Enter city/town of birth"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`countryOfCitizenship-${childIndex}`}>
                  Country Of Citizenship
                </label>
                <input
                  type="text"
                  id={`countryOfCitizenship-${childIndex}`}
                  value={childData.countryOfCitizenship}
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "countryOfCitizenship",
                      e.target.value,
                    )
                  }
                  placeholder="Enter country of citizenship"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`currentCountryOfResidence-${childIndex}`}>
                  Current Country of Residence
                </label>
                <input
                  type="text"
                  id={`currentCountryOfResidence-${childIndex}`}
                  value={childData.currentCountryOfResidence}
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "currentCountryOfResidence",
                      e.target.value,
                    )
                  }
                  placeholder="Enter current country of residence"
                />
              </div>

              <h2 className="section-title">Passport Information</h2>

              <div className="form-group">
                <label htmlFor={`passportNo-${childIndex}`}>
                  Passport Number
                </label>
                <input
                  type="text"
                  id={`passportNo-${childIndex}`}
                  value={childData.passportNo}
                  onChange={(e) =>
                    handleChange(childIndex, "passportNo", e.target.value)
                  }
                  placeholder="Enter passport number"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`issueDate-${childIndex}`}>Issue Date</label>
                <input
                  type="date"
                  id={`issueDate-${childIndex}`}
                  value={childData.issueDate}
                  onChange={(e) =>
                    handleChange(childIndex, "issueDate", e.target.value)
                  }
                />
              </div>

              <div className="form-group">
                <label htmlFor={`expiryDate-${childIndex}`}>Expiry Date</label>
                <input
                  type="date"
                  id={`expiryDate-${childIndex}`}
                  value={childData.expiryDate}
                  onChange={(e) =>
                    handleChange(childIndex, "expiryDate", e.target.value)
                  }
                />
              </div>

              <div className="form-group">
                <label htmlFor={`countryOfIssue-${childIndex}`}>
                  Country Of Issue
                </label>
                <input
                  type="text"
                  id={`countryOfIssue-${childIndex}`}
                  value={childData.countryOfIssue}
                  onChange={(e) =>
                    handleChange(childIndex, "countryOfIssue", e.target.value)
                  }
                  placeholder="Enter country of passport issue"
                />
              </div>
            </div>

            {/* Right Column */}
            <div className="form-column">
              <h2 className="section-title">Contact Information</h2>

              <div className="form-group">
                <label htmlFor={`telephoneNo-${childIndex}`}>
                  Telephone Number
                </label>
                <input
                  type="text"
                  id={`telephoneNo-${childIndex}`}
                  value={childData.telephoneNo}
                  onChange={(e) =>
                    handleChange(childIndex, "telephoneNo", e.target.value)
                  }
                  placeholder="Enter telephone number"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`emailId-${childIndex}`}>Email ID</label>
                <input
                  type="email"
                  id={`emailId-${childIndex}`}
                  value={childData.emailId}
                  onChange={(e) =>
                    handleChange(childIndex, "emailId", e.target.value)
                  }
                  placeholder="Enter email address"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`mailingAddress-${childIndex}`}>
                  Mailing Address
                </label>
                <textarea
                  id={`mailingAddress-${childIndex}`}
                  value={childData.mailingAddress}
                  onChange={(e) =>
                    handleChange(childIndex, "mailingAddress", e.target.value)
                  }
                  placeholder="Enter mailing address"
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`permanentAddress-${childIndex}`}>
                  Permanent Address
                </label>
                <textarea
                  id={`permanentAddress-${childIndex}`}
                  value={childData.permanentAddress}
                  onChange={(e) =>
                    handleChange(childIndex, "permanentAddress", e.target.value)
                  }
                  placeholder="Enter permanent address"
                  rows="3"
                />
              </div>

              <h2 className="section-title">
                Canadian Immigration Information
              </h2>

              <div className="form-group">
                <label htmlFor={`UCIno-${childIndex}`}>UCI Number</label>
                <input
                  type="text"
                  id={`UCIno-${childIndex}`}
                  value={childData.UCIno}
                  onChange={(e) =>
                    handleChange(childIndex, "UCIno", e.target.value)
                  }
                  placeholder="Enter UCI number"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`firstTimeEnteredInCanada-${childIndex}`}>
                  First Entry Date to Canada
                </label>
                <input
                  type="date"
                  id={`firstTimeEnteredInCanada-${childIndex}`}
                  value={childData.firstTimeEnteredInCanada}
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "firstTimeEnteredInCanada",
                      e.target.value,
                    )
                  }
                />
              </div>

              <div className="form-group">
                <label htmlFor={`placeOfEnteredInCanada-${childIndex}`}>
                  Place of First Entry to Canada
                </label>
                <input
                  type="text"
                  id={`placeOfEnteredInCanada-${childIndex}`}
                  value={childData.placeOfEnteredInCanada}
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "placeOfEnteredInCanada",
                      e.target.value,
                    )
                  }
                  placeholder="Enter place of first entry"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`lastTimeEnteredInCanada-${childIndex}`}>
                  Last Entry Date to Canada
                </label>
                <input
                  type="date"
                  id={`lastTimeEnteredInCanada-${childIndex}`}
                  value={childData.lastTimeEnteredInCanada}
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "lastTimeEnteredInCanada",
                      e.target.value,
                    )
                  }
                />
              </div>

              <div className="form-group">
                <label
                  htmlFor={`totalFamilyMemberIncludingSpouseAndChild-${childIndex}`}
                >
                  Family Members in Application
                </label>
                <input
                  type="number"
                  id={`totalFamilyMemberIncludingSpouseAndChild-${childIndex}`}
                  value={childData.totalFamilyMemberIncludingSpouseAndChild}
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "totalFamilyMemberIncludingSpouseAndChild",
                      e.target.value,
                    )
                  }
                  placeholder="Enter number of family members"
                  min="1"
                />
              </div>

              <div className="form-group">
                <label htmlFor={`provinceOfConsiderLiving-${childIndex}`}>
                  Preferred Province
                </label>
                <input
                  type="text"
                  id={`provinceOfConsiderLiving-${childIndex}`}
                  value={childData.provinceOfConsiderLiving}
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "provinceOfConsiderLiving",
                      e.target.value,
                    )
                  }
                  placeholder="Enter preferred province"
                />
              </div>

              <h2 className="section-title">Application History</h2>

              <div className="form-group">
                <label
                  htmlFor={`didAppliedToExpressEntryCanadaBefore-${childIndex}`}
                >
                  Applied to Express Entry Before?
                </label>
                <select
                  id={`didAppliedToExpressEntryCanadaBefore-${childIndex}`}
                  value={childData.didAppliedToExpressEntryCanadaBefore}
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "didAppliedToExpressEntryCanadaBefore",
                      e.target.value,
                    )
                  }
                >
                  <option value="">Select option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              {childData.didAppliedToExpressEntryCanadaBefore === "Yes" && (
                <div className="form-group">
                  <label htmlFor={`EEno-${childIndex}`}>
                    Express Entry Number
                  </label>
                  <input
                    type="text"
                    id={`EEno-${childIndex}`}
                    value={childData.EEno}
                    onChange={(e) =>
                      handleChange(childIndex, "EEno", e.target.value)
                    }
                    placeholder="Enter Express Entry number"
                  />
                </div>
              )}

              <div className="form-group">
                <label
                  htmlFor={`receivedNominationCertificateFromProvinceOrTerritory-${childIndex}`}
                >
                  Received Nomination Certificate?
                </label>
                <select
                  id={`receivedNominationCertificateFromProvinceOrTerritory-${childIndex}`}
                  value={
                    childData.receivedNominationCertificateFromProvinceOrTerritory
                  }
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "receivedNominationCertificateFromProvinceOrTerritory",
                      e.target.value,
                    )
                  }
                >
                  <option value="">Select option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor={`moneyBroughtToCanada-${childIndex}`}>
                  Funds for Canada (CAD)
                </label>
                <input
                  type="text"
                  id={`moneyBroughtToCanada-${childIndex}`}
                  value={childData.moneyBroughtToCanada}
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "moneyBroughtToCanada",
                      e.target.value,
                    )
                  }
                  placeholder="Enter amount in CAD"
                />
              </div>

              <h2 className="section-title">Relatives in Canada</h2>

              <div className="form-group">
                <label
                  htmlFor={`relativesInCanadaWithCitizenOrPermanentResidentOfCanada-${childIndex}`}
                >
                  Relatives in Canada? (18+ years)
                </label>
                <select
                  id={`relativesInCanadaWithCitizenOrPermanentResidentOfCanada-${childIndex}`}
                  value={
                    // childData.relativesInCanadaWithCitizenOrPermanentResidentOfCanada
                    childData?.relativesInCanada
                  }
                  onChange={(e) =>
                    handleChange(
                      childIndex,
                      "relativesInCanada",
                      e.target.value,
                    )
                  }
                >
                  <option value="">Select option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              {childData.relativesInCanada === "Yes" && (
                <>
                  <div className="form-group">
                    <label htmlFor={`name-${childIndex}`}>Name</label>
                    <input
                      type="text"
                      id={`name-${childIndex}`}
                      value={childData.name}
                      onChange={(e) =>
                        handleChange(childIndex, "name", e.target.value)
                      }
                      placeholder="Enter relative's name"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor={`relation-${childIndex}`}>Relation</label>
                    <input
                      type="text"
                      id={`relation-${childIndex}`}
                      value={childData.relation}
                      onChange={(e) =>
                        handleChange(childIndex, "relation", e.target.value)
                      }
                      placeholder="Enter relationship"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor={`statusInCanada-${childIndex}`}>
                      Status in Canada
                    </label>
                    <input
                      type="text"
                      id={`statusInCanada-${childIndex}`}
                      value={childData.statusInCanada}
                      onChange={(e) =>
                        handleChange(
                          childIndex,
                          "statusInCanada",
                          e.target.value,
                        )
                      }
                      placeholder="Enter relative's status"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor={`cityOrProvinceOfResidence-${childIndex}`}>
                      City/Province of Residence
                    </label>
                    <input
                      type="text"
                      id={`cityOrProvinceOfResidence-${childIndex}`}
                      value={childData.cityOrProvinceOfResidence}
                      onChange={(e) =>
                        handleChange(
                          childIndex,
                          "cityOrProvinceOfResidence",
                          e.target.value,
                        )
                      }
                      placeholder="Enter relative's location"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="cityOrProvinceOfResidence">
                      Status of the Relative
                    </label>
                    <select
                      id="relativesInCanadaWithCitizenOrPermanentResidentOfCanada"
                      value={childData?.relativesInCanadaResidentWith}
                      onChange={(e) =>
                        handleChange(
                          childIndex,
                          "relativesInCanadaResidentWith",
                          e.target.value,
                        )
                      }
                    >
                      <option value="">Select option</option>
                      <option value="Citizen">Citizen</option>
                      <option value="Permanent">Permanent Resident</option>
                    </select>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Immigration History Section */}
          <div className="immigration-history-section">
            <h2 className="section-title">Immigration History</h2>
            {renderImmigrationHistory(childIndex)}
          </div>

          <div className="form-footer">
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading
                ? "Processing..."
                : childExists
                  ? "Update Child Data"
                  : "Save Child Data"}
            </button>
          </div>
        </form>
        <div className="form-footer" style={{ display: "flex", gap: "25px" }}>
          <button
            onClick={() => {
              navigate(-1);
            }}
            type="button"
            className="submit-btn"
            disabled={loading}
          >
            Back
          </button>
          {completedChildDataCount === primaryApplicantChildCount && (
            <button
              onClick={() => {
                navigate("/form-fill-up-step4-education-history");
              }}
              type="button"
              className="submit-btn"
              disabled={loading}
            >
              Save and Next
            </button>
          )}
        </div>
      </>
    );
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <h1>Canadian Immigration Application - Child Details</h1>
        <p>
          Total Children: {childCount} | Please fill in all the required
          information for each child. All fields are optional.
        </p>
        <p className="instructions">
          Answer YES/NO for immigration history questions. If yes, provide
          details.
        </p>
      </div>

      {loading && (
        <div className="loading-indicator">
          <p>Loading...</p>
        </div>
      )}

      {childCount === 0 ? (
        <div className="no-children-message">
          <h3>No children found for this applicant.</h3>
          <p>
            If this is incorrect, please update the child count in the primary
            applicant form.
          </p>
        </div>
      ) : (
        <>
          {/* Child Tabs Navigation */}
          <div className="child-tabs-navigation">
            {Array.from({ length: childCount }).map((_, index) => (
              <button
                key={index}
                className={`child-tab-btn ${activeChildTab === index ? "active" : ""}`}
                onClick={() => setActiveChildTab(index)}
              >
                Child {index + 1}
                {existedDataIds[index] && (
                  <span className="saved-badge">✓</span>
                )}
              </button>
            ))}
          </div>

          {/* Render active child form */}
          {childForms.length > 0 && renderChildForm(activeChildTab)}
        </>
      )}
    </div>
  );
};

export default FormFillUpStep3;
